<ng-template #inputErrors let-control="control" let-message="message">
  @if (control.invalid && !control.pristine) {
    <div class="alert alert-danger">
      {{ message | translate }}
    </div>
  }
</ng-template>

<div class="mdsf-feedback">
  <div class="mdsf-feedback-navbar">
    <button class="closebtn" title="{{ 'close_modal' | translate }}" (click)="close()">
      <i class="fa fa-fw fa-close"></i>
    </button>
  </div>
  <h1 class="feedback-header align-middle d-flex justify-content-center text-white text-uppercase mt-4">Feedback</h1>
  <div class="mdsf-feedback-content align-middle d-flex justify-content-center">
    <form (ngSubmit)="onSubmit()" [formGroup]="feedbackForm">
      <div class="form-group">
        <input [formControl]="feedbackForm.controls.name"
          id="name"
          name="name"
          type="text"
          class="form-control search"
          placeholder="{{ 'feedback_name_placeholder' | translate }}"
          required>
        <ng-container 
          *ngTemplateOutlet="inputErrors;context:{ control: feedbackForm.controls.name, message: 'name_required'}">
        </ng-container>
      </div>
      <div class="form-group">
        <input [formControl]="feedbackForm.controls.email"
          name="email"
          type="email"
          class="form-control search"
          placeholder="{{ 'feedback_email_placeholder' | translate }}"
          required>
        <ng-container 
          *ngTemplateOutlet="inputErrors;context:{ control: feedbackForm.controls.email, message: 'mail_required'}">
        </ng-container>
      </div>
      <div class="form-group">
        <textarea [formControl]="feedbackForm.controls.message"
          name="message"
          class="form-control search"
          rows="5"
          placeholder="{{ 'feedback_message_placeholder' | translate }}"
          required>
        </textarea>
        <ng-container 
          *ngTemplateOutlet="inputErrors;context:{ control: feedbackForm.controls.message, message: 'message_required'}">
        </ng-container>
      </div>
      <div class="form-group">
        <input type="submit" class="form-control btn" [disabled]="!feedbackForm.valid || isSubmitting()" value="{{ 'send_feedback' | translate}}"/>
      </div>
    </form>
  </div>
</div>